import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageLoaderService {
  private readonly loaderSubject = new BehaviorSubject<boolean>(false);
  public readonly loader$ = this.loaderSubject.asObservable();

  public setLoader(isLoading: boolean): void {
    this.loaderSubject.next(isLoading);
  }
}
